import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=2f93437e&scoped=true"
import script from "./DocumentsList.vue?vue&type=script&lang=js"
export * from "./DocumentsList.vue?vue&type=script&lang=js"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=2f93437e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f93437e",
  null
  
)

export default component.exports